export default {"src":"/_next/static/media/nubrakes-logo.c29e0ed5.svg","height":50,"width":322};